
import { useGSAP } from "@gsap/react";
import Slider from "react-slick";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
// import SplitType from 'split-type'
// import ContactForm from '../component/form-contact';
import Header from "../component/header";
import Footer from "../component/footer"; 

import AnimatedText from "../component/animation";
// import FadeInOnScroll from "../component/scrollanimation";


// Image
// import about_01 from '../assets/appoinment.png'
// import installation_01 from '../assets/project-single.jpg'
// import background from '../assets/images/green-black.webp'

// Installation
import installation01 from '../assets/images/Homepage/Customer_Installations/1.webp'
import installation02 from '../assets/images/Homepage/Customer_Installations/2.webp'
import installation03 from '../assets/images/Homepage/Customer_Installations/3.webp'
import installation04 from '../assets/images/Homepage/Customer_Installations/4.webp'
import installation05 from '../assets/images/Homepage/Customer_Installations/5.webp'
import installation06 from '../assets/images/Homepage/Customer_Installations/Dunkel.webp'
import installation07 from '../assets/images/Homepage/Customer_Installations/Benki.webp'
import installation08 from '../assets/images/Homepage/Customer_Installations/8.webp'
import installation09 from '../assets/images/Homepage/Customer_Installations/9.webp'
import installation10 from '../assets/images/Homepage/Customer_Installations/10.webp'



import service01 from '../assets/images/Services/01.webp'
import service02 from '../assets/images/Services/02.webp'
import service03 from '../assets/images/Services/03.webp'
import service04 from '../assets/images/Services/Automation-Control-Systems.webp'
import service05 from '../assets/images/Services/05.webp'
import service06 from '../assets/images/Services/06.webp'


// import Industries01 from '../assets/images/Homepage/Our_Products_Services/Breweries.webp'
// import Industries02 from '../assets/images/Homepage/Our_Products_Services/Chemical-Plants.webp'
// import Industries03 from '../assets/images/Homepage/Our_Products_Services/Distilleries.webp'
// import Industries04 from '../assets/images/Homepage/Our_Products_Services/Food-Beverage-Processing.webp'
// import Industries05 from '../assets/images/Homepage/Our_Products_Services/Healthcare.webp'
// import Industries06 from '../assets/images/Homepage/Our_Products_Services/Pharmaceutical-Life-Sciences.webp'



// Video 
import video from '../assets/videos/videos01.mp4'

gsap.registerPlugin(ScrollTrigger);

function Services() {


        var Instalations = {
        dots: false,
      infinite: true,
        slidesToShow: 4,
        slidesToScroll: 1,
        cssEase: 'linear',
       autoplay: true,
    // speed: 300,
    // autoplaySpeed: 300,
        responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 1,
                slidesToScroll:1,
                infinite: true,
                dots: true
              }
            }
        ]
      };

    // var Industries = {
    //     dots: false,
    //   infinite: true,
    //     slidesToShow: 3,
    //     slidesToScroll: 1,
    //     cssEase: 'linear',
    //    autoplay: true,
    //     responsive: [
    //         {
    //           breakpoint: 1024,
    //           settings: {
    //             slidesToShow: 1,
    //             slidesToScroll:1,
    //             infinite: true,
    //             dots: true
    //           }
    //         }
    //     ]
    //   };
 



 useGSAP(() => {
if (window.innerWidth <= 990) return;
const cardsWrappers = gsap.utils.toArray(".card-wrapper");
const cards = gsap.utils.toArray(".card");

cardsWrappers.forEach((wrapper, i) => {
  const card = cards[i];
  let scale = 1,
    rotation = 0;
  if (i !== cards.length - 1) {
    scale = 0.9 + 0.025 * i;
    rotation = -10;
  }
  gsap.to(card, {
    scale: scale,
    rotationX: rotation,
    transformOrigin: "top center",
    ease: "none",
    scrollTrigger: {
      trigger: wrapper,
      start: "top " + (60 + 10 * i),
      end: "bottom 450",
      endTrigger: ".wrapper",
      scrub: true,
      pin: wrapper,
      pinSpacing: false,
      // markers: {
      //   indent: 100 * i,
      //   startColor: "#0ae448",
      //   endColor: "#fec5fb",
      //   fontSize: "14px"
      // },
      id: i + 1
    }
  });
});

 })

      
    return (
        <section>
            <Header/>
            <main>
               {/* ///////
                    // Section-1 */}
                    <div className="section banner-home-1">
                        <div className="basecontainer w-container">
                            <video className="image-full is--laptop" sizes="(max-width: 479px) 100vw, 98vw" autoPlay loop muted>
                                <source src={video} type='video/mp4' />
                            </video>
                            <div className="content-banner-home-1">
                                <h1 className="hero">End-to-End Process Engineering Solutions</h1>
                                {/* 
                                {/* <div className="button-banner-wrap"><a href="/arkane-services" className="primary-button">Contact Us  Now</a>
                                    <a href="/contact-arkane" className="secondary-button">Contact us</a>
                                    </div> */}
                            </div>
                        </div>
                    </div>


         
  <div className="without-top-spacing object-container section-scroll-animation animate-section-trigger">
            <div className="base-container w-container">
                <div className="section-title-center">
                    <h2 className="primary-text hero">
                        Our Services
                    </h2>
                    
                    <p>
                    <AnimatedText text="At Arkane Engineering, we deliver full-spectrum solutions — from concept design to commissioning — for process-driven industries. Our team combines deep domain expertise with advanced fabrication and automation to deliver systems that are not just functional, but future-ready."  animationType="fade-up" />
                    </p>

                </div>
            </div>
          </div> 
         
        
  
      <div className="spacer"></div>
  <div className="section service-container ">
    <div className="wrapper">
<div className="cards">
              <div className="card-wrapper animate-section-trigger">
                    <div className="base-container w-container service-content card one" >
                            
                                <div className="w-layout-grid content-home">
                                    
                                    <div className="content-about-beer">
                                        <h2 className="primary-text"><AnimatedText text="Process Design & Consulting" animationType="rotate" /></h2>
                                        <p>
                                            <AnimatedText text="From greenfield planning to brownfield expansion, our engineering team collaborates closely with clients to design process layouts that are efficient, scalable, and compliant." animationType="fade-up" />
                                        </p>
                                        
                                        {/* <div className="button-content-wrap">
                                            <a href="/contact-arkane" className="primary-button">Contact Now</a>
                                        </div> */}
                                    </div>
                                    <div className="info-about-beer">
                                        {/* <h2 className="primary-text">Our Expertise</h2> */}
                                        <div className="inf-wrapper">
                                            <h4><AnimatedText text="Process flow diagrams (PFDs) & P&IDs" animationType="scale" /></h4>
                                        </div>
                                        <div className="inf-wrapper">
                                            <h4><AnimatedText text="Compliance-focused design (ASME BPE, cGMP, S88)" animationType="scale" /></h4>
                                        </div>
                                        <div className="inf-wrapper">
                                            <h4><AnimatedText text="Material and utility planning"  animationType="scale" /></h4>
                                        </div>
                                        <div className="inf-wrapper">
                                            <h4><AnimatedText text="Feasibility analysis & value engineering" animationType="scale" /></h4>
                                        </div>
                                    
                                    </div>
                                    <div className="img-block">
                                        <div className="img-container px-400">
                                                <img src={service01} alt="Bottle of beer" className="bottle-beer" />
                                        </div>
                                    </div>
                                </div>
                            </div>
              </div>
                  

  <div className="card-wrapper animate-section-trigger">
     <div className="section base-container w-container service-content card two">
              <div className="w-layout-grid content-home">
                  <div className="content-about-beer">
                      <h2 className="primary-text"><AnimatedText text="Stainless Steel Fabrication" animationType="rotate" /></h2>
                      <p>
                          <AnimatedText text="We specialize in high-quality stainless steel fabrication for hygienic and industrial applications." animationType="fade-up" />
                      </p>
                      <p><AnimatedText text="All components are built and tested at our Bangalore manufacturing facility with stage inspections and documentation." animationType="fade-up" /></p>
                      {/* <div className="button-content-wrap">
                          <a href="/contact-arkane" className="primary-button">Contact Now</a>
                      </div> */}
                  </div>
                  <div className="info-about-beer">
                      {/* <h2 className="primary-text">Our Expertise" animationType="rotate" /></h2> */}
                        <div className="inf-wrapper"><h4><AnimatedText text="Process vessels, fermentors, and storage tanks"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Mixing and holding tanks"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Custom skids and modular systems"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Heat exchangers and CIP/SIP systems"  animationType="scale" /></h4></div>

                   
                  </div>
                  <div className="img-block">
                      <div className="img-container px-400">
                              <img src={service02} alt="Bottle of beer" className="bottle-beer" />
                      </div>

                  </div>
              </div>
          </div>
  </div>
 


  <div className="card-wrapper animate-section-trigger">
 <div className="section base-container w-container service-content card three">
              <div className="w-layout-grid content-home">
                  <div className="content-about-beer">
                      <h2 className="primary-text"><AnimatedText text="Process & Utility Piping" animationType="rotate" /></h2>
                      <p>
                           <AnimatedText text="We design and install complete piping systems that ensure smooth, safe, and efficient flow." animationType="fade-up" />
                      </p>
                    
                      {/* <div className="button-content-wrap">
                          <a href="/contact-arkane" className="primary-button">Contact Now</a>
                      </div> */}
                  </div>
                  <div className="info-about-beer">
                        <div className="inf-wrapper"><h4><AnimatedText text="Sanitary piping for food, pharma & Chemical Industry"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Utility lines (steam, water, glycol, compressed air)"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="On-site installation with qualified welders"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Pressure-tested and validated systems"  animationType="scale" /></h4></div>
                  </div>
                  <div className="img-block">
                      <div className="img-container px-400">
                              <img src={service03} alt="Bottle of beer" className="bottle-beer" />
                      </div>

                  </div>
              </div>
          </div>
  </div>
 

   <div className="card-wrapper animate-section-trigger">
<div className="section base-container w-container service-content card four">
              <div className="w-layout-grid content-home">
                  <div className="content-about-beer">
                      <h2 className="primary-text"><AnimatedText text="Automation & Control Systems" animationType="rotate" /></h2>
                      <p>
                        <AnimatedText text="Automation is at the heart of every efficient operation. We design intelligent systems that minimize manual effort and maximize operational control." animationType="fade-up" />
                      </p>
            
                      {/* <div className="button-content-wrap">
                          <a href="/contact-arkane" className="primary-button">Contact Now</a>
                      </div> */}
                  </div>
                  <div className="info-about-beer">
                        <div className="inf-wrapper"><h4><AnimatedText text="PLC & SCADA-based process automation"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Instrumentation, sensors, and HMI interfaces"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Batch control systems (S88 compliant)"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Remote monitoring and historian integration"  animationType="scale" /></h4></div>
                  </div>
                  <div className="img-block">
                      <div className="img-container px-400">
                              <img src={service04} alt="Bottle of beer" className="bottle-beer" />
                      </div>

                  </div>
              </div>
          </div>

   </div>
  
    <div className="card-wrapper animate-section-trigger">
  <div className="section base-container w-container service-content card five">
              <div className="w-layout-grid content-home">
                  <div className="content-about-beer">
                      <h2 className="primary-text"><AnimatedText text="Installation, Testing & Validation" animationType="rotate" /></h2>
                      <p>
                         <AnimatedText text="We ensure seamless on-site integration of all systems with full compliance and safety checks." animationType="fade-up" />
                      </p>
                      
                      {/* <div className="button-content-wrap">
                          <a href="/contact-arkane" className="primary-button">Contact Now</a>
                      </div> */}
                  </div>
                  <div className="info-about-beer">
                        <div className="inf-wrapper"><h4><AnimatedText text="On-site erection & commissioning"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Factory Acceptance Test (FAT) & Site Acceptance Test (SAT)"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Documentation, training & handover"  animationType="scale" /></h4></div>
                        <div className="inf-wrapper"><h4><AnimatedText text="Validation services for pharma and food-grade systems"  animationType="scale" /></h4></div>

                  </div>
                  <div className="img-block">
                      <div className="img-container px-400">
                              <img src={service05} alt="Bottle of beer" className="bottle-beer" />
                      </div>

                  </div>
              </div>
          </div>
    </div>


 <div className="card-wrapper animate-section-trigger">
 <div className="section base-container w-container service-content card">
              <div className="w-layout-grid content-home">
                  <div className="content-about-beer">
                      <h2 className="primary-text"><AnimatedText text="After-Sales Support & Maintenance" animationType="rotate" /></h2>
                      <p>
                          <AnimatedText text="We specialize in high-quality stainless steel fabrication for hygienic and industrial applications." animationType="fade-up" />
                      </p>
                   
                      {/* <div className="button-content-wrap">
                          <a href="/contact-arkane" className="primary-button">Contact Now</a>
                      </div> */}
                  </div>
                  <div className="info-about-beer">
                    <div className="inf-wrapper"><h4><AnimatedText text="Preventive maintenance contracts"  animationType="scale" /></h4></div>
                    <div className="inf-wrapper"><h4><AnimatedText text="Technical support & spare parts"  animationType="scale" /></h4></div>
                    <div className="inf-wrapper"><h4><AnimatedText text="Emergency response & service visits"  animationType="scale" /></h4></div>
                    <div className="inf-wrapper"><h4><AnimatedText text="System upgrades & retrofits"  animationType="scale" /></h4></div>
                   
                  </div>
                  <div className="img-block">
                      <div className="img-container px-400">
                              <img src={service06} alt="Bottle of beer" className="bottle-beer" />
                      </div>

                  </div>
              </div>
          </div>

 </div>
    </div>
         
 
         </div>
       </div>




        {/* <div className="spacer"></div> */}
       {/* //////// Section-5 */}
{/*         
 <div className="section backgrounds-gray object-container animate-section-trigger">
          <div className="base-container w-container">
              <div className="section-title-center">
                  <h2 className="primary-text">Industries We Serve</h2>
              </div>

              <div className="section-Instalations section-scroll-animation">
                  <Slider {...Industries}>
                      <div className="logo-container">
                          <img src={Industries01} alt="Logo" className="_img--company" />
                          <div className="-overlay service-title">
                              <span className="--h4"><AnimatedText text="Breweries & Distilleries" animationType="rotate" />
                                  </span>
                              <p><AnimatedText text="Complete brewery engineering — from pilot plants to full-scale production." animationType="fade-up" /></p>
                          </div>
                      </div>

                      <div className="logo-container">
                          <img src={Industries06} alt="Logo" className="_img--company" />
                          <div className="-overlay service-title">
                              <span className="--h4"><AnimatedText text="Pharmaceutical & Biotech" animationType="rotate" /> 
                                  </span>
                              <p><AnimatedText text="Precision-built systems for high-purity applications in cleanroom environments" animationType="fade-up" /></p>
                          </div>
                      </div>

                      <div className="logo-container">
                          <img src={Industries04} alt="Logo" className="_img--company" />
                          <div className="-overlay service-title">
                              <span className="--h4"><AnimatedText text="Food & Beverage" animationType="rotate" />
                                  </span>
                              <p><AnimatedText text="Hygienic, high-performance systems for safe and efficient food & dairy operations." animationType="fade-up" /></p>
                          </div>
                      </div>

                      <div className="logo-container">
                          <img src={Industries02} alt="Logo" className="_img--company" />
                          <div className="-overlay service-title">
                              <span className="--h4"><AnimatedText text="Chemical Processing" animationType="rotate" />
                                  </span>
                              <p><AnimatedText text="Engineered systems for precision and safety in corrosive and high-temperature environments." animationType="fade-up" /></p>
                          </div>
                      </div>

                      <div className="logo-container">
                          <img src={Industries05} alt="Logo" className="_img--company" />
                          <div className="-overlay service-title">
                              <span className="--h4"><AnimatedText text="Cosmetic Industry" animationType="rotate" />
                                  </span>
                              <p><AnimatedText text="Exquisite stainless-steel process solutions/equipment to deliver unmatched refinement and consistency in personal-care production." animationType="fade-up" /></p>
                          </div>
                      </div>
                  </Slider>
              </div>
          </div>

      </div> */}
        
   <div className="section backgrounds-gray object-container">
          <div className="base-container w-container">
              <div className="section-title-center">
                  <h2 className="primary-text">Our Installations</h2>
                  <p>
                     Our Latest Customer Installations 
                  </p>
              </div>

              <div className="section-Instalations animate-section-trigger">
                  <Slider {...Instalations}>
                      <div className="Instalations-container">
                          <img src={installation01} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Toit Brewery Project</span><p className="location">Nelamangala, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                      <div className="Instalations-container">
                          <img src={installation02} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Toit Brewery Project</span><p className="location">Nelamangala, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                      <div className="Instalations-container">
                          <img src={installation03} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Caldera Project</span><p className="location">Kolkata, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                      <div className="Instalations-container">
                          <img src={installation04} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Caldera Project</span><p className="location">Kolkata, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                      <div className="Instalations-container">
                          <img src={installation05} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Biozeen Project</span><p className="location">Bengaluru, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation06} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Dunkel Project</span><p className="location">Bengaluru, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation07} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Benki Project</span><p className="location">Bengaluru, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation08} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">The Grid Project</span><p className="location">Kolkata, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation09} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Toit Brewery Project</span><p className="location">Pune, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>

                         <div className="Instalations-container">
                          <img src={installation10} alt="Logo" className="_img--company" />
                          <div className="-overlay">
                              <span className="Instalations-name"><span className="-h4">Bonomi Project</span><p className="location">Bengaluru, India</p>
                                  </span>
                              {/* <p><AnimatedText text="Lorem ipsum dolor sit amet consectetur. Diam etiam convallis orci a sed duis elit
                                  venenatis." nimationType="fade-up"/></p> */}
                          </div>
                      </div>
                  </Slider>
              </div>
          </div>

      </div>
      

            </main>
            <Footer/>
        </section>
    )
}

export default Services;